// src/audio/wav.ts — wrap 16 kHz mono Int16 PCM as a WAV container for generateContent
// inline audio input (talk-mode transcription). Returns base64 (no data: prefix).
export function pcm16kToWavBase64(pcm: Int16Array, hz = 16000): string {
  const bytesPerSample = 2;
  const blockAlign = bytesPerSample;
  const byteRate = hz * blockAlign;
  const dataLen = pcm.length * bytesPerSample;
  const buf = new ArrayBuffer(44 + dataLen);
  const v = new DataView(buf);
  const w = (o: number, s: string) => {
    for (let i = 0; i < s.length; i++) v.setUint8(o + i, s.charCodeAt(i));
  };
  w(0, "RIFF");
  v.setUint32(4, 36 + dataLen, true);
  w(8, "WAVE");
  w(12, "fmt ");
  v.setUint32(16, 16, true); // PCM fmt chunk size
  v.setUint16(20, 1, true); // audio format = PCM
  v.setUint16(22, 1, true); // mono
  v.setUint32(24, hz, true);
  v.setUint32(28, byteRate, true);
  v.setUint16(32, blockAlign, true);
  v.setUint16(34, 16, true); // bits per sample
  w(36, "data");
  v.setUint32(40, dataLen, true);
  for (let i = 0; i < pcm.length; i++) v.setInt16(44 + i * 2, pcm[i], true);

  // base64 encode without overflowing the call stack on large clips
  let bin = "";
  const bytes = new Uint8Array(buf);
  for (let i = 0; i < bytes.length; i += 0x8000) {
    bin += String.fromCharCode(...bytes.subarray(i, i + 0x8000));
  }
  return btoa(bin);
}
